import { Component, OnDestroy, OnInit } from '@angular/core';
import { trackByRef } from 'src/app/lego-utils';
import { Subscription } from 'rxjs';
import { UnitsOfMeasureService } from 'src/app/state';

@Component({
  selector: 'em-units-of-measure',
  templateUrl: './units-of-measure.component.html',
  standalone: false,
})
export class UnitsOfMeasureComponent implements OnInit, OnDestroy {
  public uom$ = this.unitsOfMeasureService.unitsOfMeasure$;
  public isLoading$ = this.unitsOfMeasureService.loading$;
  public error$ = this.unitsOfMeasureService.error$;
  public readonly trackByRef = trackByRef;

  private readonly subscriptions = new Subscription();

  public constructor(private readonly unitsOfMeasureService: UnitsOfMeasureService) {}

  public ngOnInit(): void {
    this.subscriptions.add(this.unitsOfMeasureService.loadByDesignId().subscribe());
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
